import axios from 'axios';
import config from '../config/config';

class StatusScreenApi {
    static basic() {
        return axios.get(`${config.server.endpoint}backend/statusScreen/basic`)
    }

    static pingGoogle() {
        return axios.get('http://www.volkramweber.de')
    }
}

export default StatusScreenApi;
